module.exports = __webpack_public_path__ + "static/media/icon-live-ic-clear.442b60a0.svg";